(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

function cart_spin() {

    $(".custom-spinner").spinner({
        min: 1
    });

}

$(document).on('shopify:section:select', cart_spin);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
function  prceload() {
$(function() {

    $('.minamount').val('0');
    $('.maxamount').val('0');
    var cursbl = String($("#product_collection .product_price").find(".price").find('.money').eq(0).text().replace(/-?[0-9]*\.?[0-9]+/, ""));
    var prices = [];
    $("#product_collection .product_price").each(function() {
      var price2 = parseInt($(this).data('price'), 10);
      prices.push(price2);
    });

    $("#product_collection .product_price").find(".price").each(function() {

      var number = Number($(this).find('.money').eq(0).text().replace(/[^0-9\.-]+/g, ""));
      var price2 = parseInt(number, 10);
      prices.push(price2);
      $(this).closest(".product_price").data('price', price2);


    });
    prices.sort(function(a, b) {
      return a - b
    });
    var low = Math.min.apply(Math, prices);

    var high = Math.max.apply(Math, prices);
    slider_updt(low, high, cursbl);
    $("#search-price").click(function() {

      var min = $('.minamount').data('prod_price_min'),
          max = $('.maxamount').data('prod_price_max');
      showProducts(min, max);

    });
  });
}
$(document)
 .on('shopify:section:load', prceload );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-template"]) return;
  try {
    
function prceload() {
$(function() {

$('.minamount').val('0');
$('.maxamount').val('0');
var cursbl = String($("#product_collection .product_price").find(".price").find('.money').eq(0).text().replace(/-?[0-9]*\.?[0-9]+/, ""));
var prices = [];
$("#product_collection .product_price").each(function() {
var price2 = parseInt($(this).data('price'), 10);
prices.push(price2);
});

$("#product_collection .product_price").find(".price").each(function() {

var number = Number($(this).find('.money').eq(0).text().replace(/[^0-9\.-]+/g, ""));
var price2 = parseInt(number, 10);
prices.push(price2);
$(this).closest(".product_price").data('price', price2);


});
prices.sort(function(a, b) {
return a - b
});
var low = Math.min.apply(Math, prices);

var high = Math.max.apply(Math, prices);
slider_updt(low, high, cursbl);
$("#search-price").click(function() {

var min = $('.minamount').data('prod_price_min'),
max = $('.maxamount').data('prod_price_max');
showProducts(min, max);

});
});
}
$(document)
.on('shopify:section:load', prceload );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slider"]) return;
  try {
    

function revload() {
  jQuery('.tp-banner').revolution(
			{
				delay:8000,
				startwidth:1170,
				startheight:860,
				hideThumbs:0,
				navigationStyle:'custom-bullets',
				navigationVAlign:'bottom',
				navigationHAlign:'right',
					
				soloArrowRightHalign:'right',
			    soloArrowRightValign:'bottom',
			    soloArrowRightHOffset:22,
			    soloArrowRightVOffset:120,
			
				soloArrowLeftHalign:'right',
			    soloArrowLeftValign:'bottom',
			    soloArrowLeftHOffset:22,
			    soloArrowLeftVOffset:120
			});
			//positioning the left (up) arrow on the slider
			var bottommargin = $('.tp-bullets').height() + 33 + 'px';
			$('.tp-leftarrow').css('margin-bottom', bottommargin);
			
			// Adding numbers to pages
			var rs_pages_count = $('.tp-banner li').length;
			$('#rs-pages').html('<span>' + rs_pages_count + '</span>');
    				
    			for (var i = 0; i < $('.tp-banner li').length; i++) {
    				var slides = $('.tp-banner li #rs-current-page');
    				var selector = slides[i];
    				$(selector).html(i + 1);
    			}
    		
    
    }
     
    $(document)
     .on('shopify:section:load', revload )
    ;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

$(document).on('shopify:section:select', prod_tabload);


  } catch(e) { console.error(e); }
})();

})();
